// Animated underline
const initAnimatedUnderlines = (elements) => {

	var AnimatedUnderline = function (element) {
		this.element = element;
		// If we dont have everything we need, abort
		if(!this.element) return
		// else get setup and observe the elements
		const observer = new IntersectionObserver(underlineInView);
		observer.observe(this.element);
	};

	// Function runs when the element is in view
	const underlineInView = elements => {
		elements.forEach((element) => {
			if (element.isIntersecting) {
				element.target.classList.add('in-view');
			}
		});
	};

	if (elements.length > 0) {
		for (var i = 0;i < elements.length;i++) {
			(function (i) { new AnimatedUnderline(elements[i]);})(i);
		}
	}
}

export default initAnimatedUnderlines;
